<div class="loading">
  <div class="box">
    <ion-spinner name="crescent" color="accent"></ion-spinner>
    <p>{{ label() }}</p>
  </div>
</div>